import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';
import { PresencePersonaLoading } from './components/PresencePersonaLoading';
import type { PresencePersonaBadgeProps } from './components/PresencePersonaBadgeProps';
import type { PersonaControlWrapperWithPresenceProps } from './components/PersonaControlWrapperWithPresence';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "PersonaPresenceBadge" */ './lazyIndex'),
    { name: 'PersonaPresenceBadge' }
);

export const PresencePersonaBadge: LazyComponent<PresencePersonaBadgeProps, any, void> =
    createLazyComponent<PresencePersonaBadgeProps, any, any>(
        lazyModule,
        m => m.PresencePersonaBadge,
        PresencePersonaLoading
    );

export const PersonaControlWrapperWithPresence: LazyComponent<
    PersonaControlWrapperWithPresenceProps,
    any,
    void
> = createLazyComponent<PersonaControlWrapperWithPresenceProps, any, any>(
    lazyModule,
    m => m.PersonaControlWrapperWithPresence
);
